import Form from './form';
import FormItem from './form-item';

/* istanbul ignore next */
Form.install = function(Vue) {
  Vue.component(Form.name, Form);
  Vue.component(FormItem.name, FormItem);
};

export default Form;
